import React from 'react'
import Helmet from 'react-helmet';
import Column from '../shared/components/layout/column';
import Card from '../shared/components/card/card';
import Row from '../shared/components/layout/row';
import ConnectSection from './connect/connect-section';

const ServerLocator = () => (
    <div className="mx-lg">
        <Helmet>
            <title>Culley Studios | Server Locator</title>
        </Helmet>
        <Column className="flex-a-items-center w-9 w-max m-auto overflow-hidden">
            <Row className="flex-mb-wrap w-10 gap-md float-in">
                <img className="w-3 w-mb-6 py-md" src="https://culleystudios.com/images/sl-logo-text.png" alt="Server Locator Logo" />
            </Row>
            <Row className="flex-mb-wrap w-10 gap-md py-lg float-in">
                <Card className="w-10 w-max float-in"
                    headerClass="bg-tertiary"
                    header={
                        <div>
                            <h2 className="mx-md">Server Locator (2017–2026) | Thank You for the Journey</h2>
                            <hr className="primary w-10 m-none"/>
                        </div>
                    }
                    bodyClass="bg-secondary"
                    body={
                        <div className="p-lg">
                            <p>
                                After 9 incredible years, we have made the difficult decision to close Server Locator for the foreseeable future.
                            </p>
                            <p>
                                While the platform never grew to a massive scale, building and running it has been an incredibly fun and rewarding journey. Taking an idea, spinning it up into a live service, and watching real Minecraft server communities use it was something we never took for granted. Seeing servers get listed, players discover new communities, and projects grow because of a simple idea we brought to life was truly special.
                            </p>
                            <p>
                                Unfortunately, the ongoing costs of keeping the platform online without revenue to support it mean that it is no longer sustainable to continue operating it. For now, Server Locator is coming to a close. That said, this may not be goodbye forever.
                            </p>
                            <p>
                                We are deeply grateful to every Minecraft server owner who trusted us with their listing and to every player who used the site to find a new place to play. Even though we remained a smaller platform, the support and enthusiasm from this community made the entire experience worthwhile.
                            </p>
                            <p>
                                This change does not affect our Minecraft plugin development at all. We are continuing to actively develop, maintain, and support our plugins for Minecraft servers, and we have no plans to step away from that. Supporting server owners through our tools remains a core part of what we do.
                            </p>
                            <p>
                                Thank you for being part of this journey with us. It has genuinely been a pleasure.
                            </p>
                        </div>
                    }
                />
                <br/>
            </Row>
        </Column>
        <ConnectSection />
    </div>
)

export default ServerLocator;